import React, { Component } from "react";
import { FormGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import classnames from "classnames";
import ReactPixel from "react-facebook-pixel";

import { fetchWorkRelationships } from "../../../../actions/dropdowns.actions";
import Button from "../../../../components/common/button/Button";

import styles from "./Confirmation.scss";

class Confirmation extends Component {
  constructor(props) {
    super(props);

    this.redirectToFAQ = this.redirectToFAQ.bind(this);
  }

  componentDidMount() {
    ReactPixel.init("727220614296789");
    ReactPixel.track("CompleteSignUp");
  }

  redirectToFAQ() {
    window.open("https://thesecondshift.freshdesk.com/support/home");
  }

  render() {
    return (
      <section className={styles.confirmation}>
        <div className={styles.content}>
          <h1>Almost there.</h1>

          <div className={styles.form}>
            <FormGroup>
              <div className={styles.subheading}>
                To ensure we have only the highest quality candidates available
                for our companies, we check endorsements and personally
                interview every member.
              </div>
            </FormGroup>
            <div className={styles.dividerDouble} />
            <h2>Here’s what’s next:</h2>
            &nbsp;
            <Row>
              <Col md={1} xs={1}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="37"
                  viewBox="0 0 29 37"
                >
                  <path
                    fill="none"
                    fillRule="evenodd"
                    stroke="#95CFB3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M9.45 24.564h2.557v-2.708H9.45v2.708zM22.633 1v5.216h5.284m0 23.735c0 .57-.468
                    1.043-1.044  1.043H6.5c-.577 0-1.04-.474-1.04-1.043v-27.9c0-.57.463-1.05 1.04-1.05h16.133c.274 0
                    .402.116.597.305l4.375 4.263c.198.193.311.463.311.738v23.644zM2.084 5.453c-.6 0-1.084.485-1.084
                    1.083v27.78c0 .6.484 1.085 1.084 1.085H23.89c.598 0 1.083-.485 1.083-1.084M14.846 12.67h9.079M9.45
                    13.98h2.557v-2.708H9.45v2.708zm5.396 3.98h9.079M9.45
                    19.274h2.557v-2.708H9.45v2.708zm5.396 3.98h9.079"
                  />
                </svg>
              </Col>
              <Col md={11} xs={11}>
                <div
                  className={classnames(
                    styles.sectionDescription,
                    styles.sectionDescriptionTitle
                  )}
                >
                  <b>1. Checking Your Credentials</b>
                </div>
                <div className={styles.sectionDescription}>
                  Our member success team looks at your work history to be sure
                  it meets our criteria. Remember that all candidates must have
                  a minimum of 10 years work experience in their selected field,
                  and must have been actively working within the past two years.
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={1} xs={1}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="38"
                  viewBox="0 0 29 38"
                >
                  <path
                    fill="none"
                    fillRule="evenodd"
                    stroke="#95CFB3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M19.11
                      4.232h-1.902V3.194c0-1.212-1.03-2.194-2.295-2.194h-1.156c-1.267
                      0-2.296.982-2.296 2.194v1.038H9.483c-3.029 0-3.076 4.546 0 4.546h9.626c3.067 0 3.059-4.546
                      0-4.546zm5.388 1.422h3.171V37H1V5.654h3.14m3.31 18.992l3.975 4.382 10.27-12.432"
                  />
                </svg>
              </Col>
              <Col md={11} xs={11}>
                <div
                  className={classnames(
                    styles.sectionDescription,
                    styles.sectionDescriptionTitle
                  )}
                >
                  <b>2. Endorsements</b>
                </div>
                <div className={styles.sectionDescription}>
                  It usually takes a few days for your colleagues to provide
                  their endorsements. Ask them to keep an eye out for an email
                  from us.
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={1} xs={1}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="37"
                  height="32"
                  viewBox="0 0 37 32"
                >
                  <path
                    fill="none"
                    fillRule="evenodd"
                    stroke="#95CFB3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M7.025 14.5h14.871m1.549-6H5.693C3.18 8.5 1 10.524 1 13.018v7.446C1 22.96
                    3.18 25 5.694 25H7v4.422c0 .974.978 1.488 1.697.827L14.216 25h9.228C25.957
                    25 28 22.96 28 20.464v-7.446c0-2.494-2.043-4.518-4.555-4.518zm7.854
                    7.505c2.301-.26 4.2-2.211 4.2-4.581V5.613C35.499 3.064 33.213 1 30.666
                    1h-14.78c-2.398 0-4.134 1.835-4.356 4.173M7.025 19h14.871"
                  />
                </svg>
              </Col>
              <Col md={11} xs={11}>
                <div
                  className={classnames(
                    styles.sectionDescription,
                    styles.sectionDescriptionTitle
                  )}
                >
                  <b>3. Staff Interview</b>
                </div>
                <div className={styles.sectionDescription}>
                  After your endorsements check out, a member of The Second
                  Shift team will contact you to schedule a 30-minute interview.
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={1} xs={1}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="32"
                  viewBox="0 0 34 32"
                >
                  <path
                    fill="none"
                    fillRule="evenodd"
                    stroke="#95CFB3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M27.397 17.651v7.336c0 1.62-.657
                    3.087-1.717 4.149a5.847 5.847 0 0 1-4.149 1.717H6.866a5.847 5.847 0 0 1-4.148-1.717A5.852
                    5.852 0 0 1 1 24.987V10.315c0-1.62.657-3.087 1.718-4.148a5.847 5.847 0 0 1
                    4.148-1.718h14.665M8.35 15.706l6.688 7.47L33 1"
                  />
                </svg>
              </Col>
              <Col md={11} xs={11}>
                <div
                  className={classnames(
                    styles.sectionDescription,
                    styles.sectionDescriptionTitle
                  )}
                >
                  <b>4. Approval</b>
                </div>
                <div className={styles.sectionDescription}>
                  Once you pass the interview, your new homepage will be live –
                  along with a list of projects that match your skills and
                  location preferences.
                </div>
              </Col>
            </Row>
            <div className={styles.dividerDouble} />
            <b>
              <p>Still have questions?</p>
            </b>
            <Button
              isPrimary
              type="button"
              size={"large"}
              onClick={this.redirectToFAQ}
              label="READ OUR FAQ"
            />
            <a href="https://thesecondshift.com/contact-us">
              <span className={styles.bottomLink}>
                Or contact a Second Shift admin ›
              </span>
            </a>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    workRelations: state.dropdowns.workRelationship.data
  };
};

const mapDispatchToProps = dispatch => ({
  fetchWorkRelationships: () => dispatch(fetchWorkRelationships())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation);



// WEBPACK FOOTER //
// ./src/routes/candidate/confirmationScreen/components/Confirmation.js